import React, { useState, useEffect } from "react";

export const CrossfadeCarousel = ({ images, interval = 4200, fade = 2400 }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const id = setInterval(() => setIndex((i) => (i + 1) % images.length), interval);
    return () => clearInterval(id);
  }, [images, interval]);

  return (
    <div className="relative aspect-[3/4] overflow-hidden bg-[#0A0A0A]" data-testid="problem-carousel">
      {images.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          aria-hidden={i !== index}
          loading={i === 0 ? "eager" : "lazy"}
          className="absolute inset-0 h-full w-full object-cover will-change-[opacity]"
          style={{ opacity: i === index ? 1 : 0, transition: `opacity ${fade}ms ease-in-out` }}
        />
      ))}
      <div className="absolute inset-0 bg-[#0A0A0A]/20 pointer-events-none" />
    </div>
  );
};
